



























import Vue from 'vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'HomeContest',
  components: {
    Block,
  },
  data: () => ({}),
})
